import store from '@/store/'

const HOLIDAYS = [
    // 🎆 New Year
    {
        id: 'newyear',
        priority: 100,
        match: (m, d) => (m === 11 && d === 31) || (m === 0 && d <= 1),
        greeting: "🎆 Happy New Year",
        personalize: true,
        buttonColor: "#FFD600"
    },

    // 💖 Valentine’s Day
    {
        id: 'valentine',
        priority: 90,
        match: (m, d) => m === 1 && d === 14,
        greeting: "💖 Happy Valentine’s Day",
        personalize: true,
        buttonColor: "#D81B60"
    },

    // 🧧 Lunar New Year
    {
        id: 'lunar',
        priority: 85,
        match: (m, d) => m === 1 && d === 6,
        greeting: "🧧 Happy Lunar New Year",
        personalize: true,
        buttonColor: "#C62828"
    },

    // ☪️ Eid al-Fitr
    // NOTE: Sample static date only
    {
        id: 'eid',
        priority: 80,
        match: (m, d) => m === 2 && d === 20,
        greeting: "☪️ Eid al-Fitr Mubarak",
        personalize: false,
        buttonColor: "#388E3C"
    },

    // ✝️ Holy Week
    // NOTE: Sample static date only
    {
        id: 'holyweek',
        priority: 70,
        match: (m, d) => m === 3 && d >= 1 && d <= 5,
        greeting: "✝️ Have a Blessed Holy Week",
        personalize: false,
        buttonColor: "#5D4037"
    },

    // 🇵🇭 Day of Valor
    {
        id: 'valor',
        priority: 75,
        match: (m, d) => m === 3 && d === 9,
        greeting: "🇵🇭 Remembering the Day of Valor",
        personalize: false,
        buttonColor: "#0288D1",
        localOnly: true
    },

    // 💼 Labor Day
    {
        id: 'laborday',
        priority: 75,
        match: (m, d) => m === 4 && d === 1,
        greeting: "💼 Happy Labor Day",
        personalize: true,
        buttonColor: "#007ACC",
        localOnly: true
    },

    // ☪️ Eid al-Adha
    // NOTE: Sample static date only
    {
        id: 'eid',
        priority: 80,
        match: (m, d) => m === 4 && d === 27,
        greeting: "☪️ Eid al-Adha Mubarak",
        personalize: false,
        buttonColor: "#388E3C"
    },

    // 🇵🇭 Independence Day
    {
        id: 'independence',
        priority: 75,
        match: (m, d) => m === 5 && d === 12,
        greeting: "🇵🇭 Happy Independence Day",
        personalize: true,
        buttonColor: "#20a7db",
        localOnly: true
    },

    // 🕊 Ninoy Aquino Day
    {
        id: 'ninoy',
        priority: 70,
        match: (m, d) => m === 7 && d === 21,
        greeting: "🕊 Honoring Benigno 'Ninoy' Aquino Jr.",
        personalize: false,
        buttonColor: "#a67c00",
        localOnly: true
    },

    // 🦸 National Heroes Day
    {
        id: 'heroesday',
        priority: 70,
        match: (m, d) => m === 7 && d === 31,
        greeting: "🦸 Honoring Our National Heroes",
        personalize: false,
        buttonColor: "#20a7db",
        localOnly: true
    },

    // 🎃 Halloween
    {
        id: 'halloween',
        priority: 70,
        match: (m, d) => m === 9 && (d === 30 || d === 31),
        greeting: "🎃 Happy Halloween",
        personalize: true,
        buttonColor: "#FB8C00"
    },

    // 🕯 All Saints’ Day
    {
        id: 'allsaints',
        priority: 80,
        match: (m, d) => m === 10 && d >= 1 && d <= 2,
        greeting: "🕯 Remembering Our Departed Loved Ones",
        personalize: false,
        buttonColor: "#757575",
        localOnly: true
    },

    // 🇵🇭 Bonifacio Day
    {
        id: 'bonifacio',
        priority: 75,
        match: (m, d) => m === 10 && d === 30,
        greeting: "🇵🇭 Honoring Andres Bonifacio",
        personalize: false,
        buttonColor: "#C62828",
        localOnly: true
    },

    // 🎄 Christmas
    {
        id: 'christmas',
        priority: 10,
        match: (m, d) => m === 11 && d >= 21 && d <= 25,
        greeting: "🎄 Merry Christmas",
        personalize: true,
        buttonColor: "#00695C"
    },

    // 🙏 Immaculate Conception
    {
        id: 'immaculate',
        priority: 90,
        match: (m, d) => m === 11 && d === 8,
        greeting: "🙏 Feast of the Immaculate Conception",
        personalize: false,
        buttonColor: "#3F51B5",
        localOnly: true
    },

    // 🇵🇭 Rizal Day
    {
        id: 'rizalday',
        priority: 95,
        match: (m, d) => m === 11 && d === 30,
        greeting: "🇵🇭 Honoring Dr. José Rizal",
        personalize: false,
        buttonColor: "#0038A8",
        localOnly: true
    }
]

export default {

    getSeasonDetails(queryAction = null, isMobile = false) {

        const firstName = store.state.firstName

        const today = new Date()
        const month = today.getMonth()
        const day = today.getDate()
        const hour = today.getHours()

        // Better tenant/user localization check
        // Replace with company country if available
        const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone

        const isPH = userTimeZone === "Asia/Manila" ||
            (navigator.language || "").toLowerCase().indexOf("ph") >= 0

        // ---------------------------------------------------
        // 1. Query Action Messages (Highest Priority)
        // ---------------------------------------------------

        const actionMessages = {
            expired: "You've been logged out due to inactivity",
            expired_token: "You've been logged out due to inactivity",
            change_password: "Your password has been successfully changed",
            user_initiated: "You've been logged out successfully"
        }

        if (queryAction && actionMessages[queryAction]) {

            return {
                greeting: actionMessages[queryAction],
                personalize: false,
                buttonColor: "#1976D2",
                className: isMobile
                    ? "welcome-section-mobile"
                    : "welcome-section"
            }
        }

        // ---------------------------------------------------
        // 2. Find Matching Holidays
        // ---------------------------------------------------

        const matchedHolidays = HOLIDAYS.filter(h => {

            if (h.localOnly && !isPH)
                return false

            return h.match(month, day)
        })

        // Highest priority wins
        matchedHolidays.sort((a, b) => b.priority - a.priority)

        const holiday =
            matchedHolidays.length > 0
                ? matchedHolidays[0]
                : null

        // ---------------------------------------------------
        // 3. Time Greeting Fallback
        // ---------------------------------------------------

        const getTimeGreeting = () => {

            if (hour < 12)
                return "Good morning"

            if (hour < 18)
                return "Good afternoon"

            return "Good evening"
        }

        // ---------------------------------------------------
        // 4. Build Default State
        // ---------------------------------------------------

        const result = {
            greeting: null,
            personalize: false,
            buttonColor: "#1976D2",
            className: isMobile
                ? "welcome-section-mobile"
                : "welcome-section"
        }

        // ---------------------------------------------------
        // 5. Holiday State
        // ---------------------------------------------------

        if (holiday) {

            result.personalize = holiday.personalize
            result.buttonColor = holiday.buttonColor

            result.className = isMobile
                ? "welcome-section-" + holiday.id + "-mobile"
                : "welcome-section-" + holiday.id

            let greeting = holiday.greeting

            // Personalized Greeting
            if (holiday.personalize && firstName) {

                greeting += ", " + firstName
            }

            result.greeting = greeting

            return result
        }

        // ---------------------------------------------------
        // 6. Standard Greetings
        // ---------------------------------------------------

        if (firstName) {

            result.greeting =
                getTimeGreeting() +
                ", <strong>" +
                firstName +
                "</strong>!"

        } else {

            result.greeting =
                "Welcome to <strong>SweldoNow</strong>"
        }

        return result
    }
}